import { render, staticRenderFns } from "./MemorizingWords2.vue?vue&type=template&id=cbec2c00&"
import script from "./MemorizingWords2.vue?vue&type=script&lang=js&"
export * from "./MemorizingWords2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports